import {FormikValues} from "formik";
import {get, isArray} from "lodash";

export const getFormErrorText = (form: FormikValues, key: string | string[], isEditing?: boolean) => {
    key = isArray(key) && key.length === 1 ? key[0] : key;
    return (
        !form.isValid &&
        ((get(form.touched, key) && get(form.errors, key)) ||
            (isEditing && !get(form.values, key) && get(form.errors, key)))
    );
};
